import { FC } from 'react';
import { WarrantyDetail } from '@/components/projects/WarrantyDetail/WarrantyDetail';
import { WarrantyPartsList } from '@/components/projects/WarrantyPartsList/WarrantyPartsList';
import { InfoCard } from '@/components/uiParts/InfoCard/InfoCard';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { WARRANTY_STATUS } from '@/consts/warranty';
import { WarrantiesAppendWarranty, Warranty } from '@/types/api/customerApi';
import {
  switchWarrantyPartsTitleByCoverageType,
  WarrantyPartsType,
} from '@/utils/warranty';
import './warrantyPartsStyle.scss';

interface WarrantyPartsProps {
  currentWarranty: Warranty | undefined;
  appendWarranty: WarrantiesAppendWarranty | undefined;
  warrantyParts: WarrantyPartsType;
}

export const WarrantyParts: FC<WarrantyPartsProps> = ({
  currentWarranty,
  appendWarranty,
  warrantyParts,
}) => {
  const isWarrantyExpired =
    appendWarranty?.warranty_status === WARRANTY_STATUS.EXPIRED;
  const warrantyPlanTitle = isWarrantyExpired
    ? '失効した保証プラン'
    : 'ご契約中の保証プラン';

  return (
    <PageTemplate
      pageName="WarrantyManagement"
      title={warrantyPlanTitle}
      showNavBack
    >
      <div className="home__wrapper">
        <div className="u-margin-top-sm">
          <RoundSheet>
            <div className="WarrantyDetail-title">{warrantyPlanTitle}</div>
            {isWarrantyExpired && (
              <InfoCard
                className="warning-card"
                bgColor="warning"
                text="保証が失効しています"
                iconType="confirm-notification"
              />
            )}
            <WarrantyDetail
              warrantyInfo={appendWarranty}
              warrantyNo={currentWarranty?.warranty_no ?? ''}
            />
            {/* 保証対象部位一覧 */}
            <div className="sheet-top">
              <div className="WarrantyDetail-title">
                {switchWarrantyPartsTitleByCoverageType(
                  appendWarranty?.covering_type,
                )}
                一覧
              </div>
              {appendWarranty?.covering_type !== null && (
                <WarrantyPartsList warrantPartsList={warrantyParts} />
              )}
            </div>
          </RoundSheet>
        </div>
      </div>
    </PageTemplate>
  );
};
